const messages = {
  step3: {
    actionBtn: "Prijava",
  },
};

export default {
  messages,
};
